import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsKayakingNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M11.17 19.89v.73a10.68 10.68 0 001.24 4.98l2.91 5.4h1.36l2.91-5.41a10.609 10.609 0 001.24-4.97v-5.87l-1.66.88v4.99a9.036 9.036 0 01-1.04 4.2L16 28.79l-2.13-3.97a9.036 9.036 0 01-1.04-4.2V19z" />
        <path d="M17.5 19.03v-2.51l-3 1.6v.91a1.5 1.5 0 103 0zm6.15-9.61v.12l-2.82 1.5a10.666 10.666 0 00-1.26-4.88L16.77 1h-1.55l-2.8 5.17a10.74 10.74 0 00-1.25 5v5l-3.73 1.99-.07-.05a3.155 3.155 0 00-3.27-.17L.17 20.03v5.56l5.27-2.8a3.311 3.311 0 001.19-1.07l1.33-1.96v-.01l16.78-8.92h2.32a3.33 3.33 0 001.55-.39l3.22-1.7V3.17l-6.49 3.44a3.187 3.187 0 00-1.69 2.81zM5.27 20.79a1.631 1.631 0 01-.6.54l-2.84 1.51v-1.82l3.05-1.63a1.548 1.548 0 011.36-.03zm13.9-8.87l-1.69.9A1.483 1.483 0 0016 11.46a1.507 1.507 0 00-1.5 1.51v1.43l-1.67.89v-4.12a8.974 8.974 0 011.05-4.22L16 3.03l2.11 3.91a8.934 8.934 0 011.06 4.23zm6.94-3.85l4.06-2.15v1.82l-2.33 1.24c-.24.127-.508.192-.78.19h-1.74a1.54 1.54 0 01.79-1.1z" />
      </g>
    </svg>
  )
);
SvgSportsKayakingNormalMedium.defaultProps = {
  color: 'currentColor',
  size: 32,
  title: undefined,
  titleId: undefined
};
SvgSportsKayakingNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsKayakingNormalMedium;
